"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
const styleOverrides = {
  root: {
    backgroundColor: _constants.colors.defaultColors.main,
    color: _constants.colors.defaultColors.contrastText
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiSnackbarContent.js.map